import React from 'react'
import { Span } from '@pcln/horizon'

export const RadioPropItems = [
  {
    labelNode: <Span className="">Single Hotel</Span>,
    value: 'SH',
    name: 'hotelType',
    disabled: false,
    size: '20' as const
  },
  {
    labelNode: <Span className="">Multi Hotel</Span>,
    value: 'MH',
    name: 'hotelType',
    disabled: false,
    size: '20' as const
  }
]

export default RadioPropItems
